import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../axiosBaseQuery";


const userRoleApi = createApi({
    reducerPath: "base/userRole",
    baseQuery: axiosBaseQuery,
    tagTypes: ["userRoleList"],
    endpoints: (builder) =>({
        userRoleFindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
            providesTags: ['userRoleList'],
            query: (query = '') => ({
                url: "/base/userRole" + query,
                method: "GET",
            }),
            transformResponse: (response: any) => {
                return {
                    data: response.data,
                    pagination: response?.pagination,
                };
            },
        }),
        userRoleCreate: builder.mutation({
            invalidatesTags: ['userRoleList'],
            query: (data)=>({url: "/base/userRole", method: "POST", data})
        }),
        userRoleUpdate: builder.mutation({
            invalidatesTags: ['userRoleList'],
            query: (data)=>({url: "/base/userRole/"+data.id, method: "PUT", data})
        }),
        // console.log(data);
        
        userRoleDelete: builder.mutation({
            invalidatesTags: ['userRoleList'],
            query: (id)=>({url: "/base/userRole/"+id, method: "DELETE"})
        }),
    })
})

export const { useUserRoleFindAllQuery, useUserRoleCreateMutation, useUserRoleUpdateMutation, useUserRoleDeleteMutation } = userRoleApi;
export {userRoleApi};
